/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import { withRouter,Route, Switch,BrowserRouter as Router,Redirect } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "assets/sass/light-bootstrap-dashboard-pro-react.scss?v=1.2.0";
import "assets/css/demo.css";
import "assets/css/pe-icon-7-stroke.css";

import AuthLayout from "layouts/Auth.jsx";
import AdminLayout from "layouts/Admin.jsx";
import NotFoundPage from "views/Tables/RegularTables.jsx"
import  {initializeClarity} from './utils/Clarity.js';
const loggedIn = "false"
const token = localStorage.getItem('user')

initializeClarity()
ReactDOM.render(
  <React.Fragment>
  <Router>
      <Switch>
        <Route path="/auth" render={props => <AuthLayout {...props} />} />
        <Route path="/admin" render={props => <AdminLayout {...props} />} />
{ token == null || token == "" ? <Redirect from="/" to="/auth/login-page" />   :<Redirect from="/" to="/admin/dashboard" />}
         
          <Redirect to="admin/notfount" />
      </Switch>
    </Router>
    </React.Fragment>,
  document.getElementById("root")
);
